export default __webpack_public_path__ + "static/media/snack.e330c4e5.svg";